import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const CurrencyTextField = styled(TextField)({
  '& input': {
    textAlign: 'left',
  },
});


const Main = ({ default_value, value, show_message, onChange }) => {
  const [input_value, setInputValue] = useState(value?.value)
  const [has_warning, setHasWarning] = useState(false)

  useEffect(() => {
    if(default_value) {
      doSetValue(default_value)
    }
  }, [])

  const doSetValue = (newValue) => {
    setInputValue(newValue)

    if(onChange) {
      onChange({...value, value: newValue})
    }
  }

  const hasMoreThanTwoDecimalPlaces = (input) => {
    if(input) {
      return input.split('.')[1]?.length > 2
    } else {
      return false
    }
  }

  const needsWarning = () => {
    return has_warning || hasMoreThanTwoDecimalPlaces(input_value)
  }

  return (
    <>
      <CurrencyTextField
        value={value?.value}
        type="number"
        // label="Unit Price"
        color={needsWarning() ? 'warning' : 'primary'}
        onKeyDown={(e) => {
          if (e.key === 'e' || e.key === '-' || e.key === '+') {
            e.preventDefault()
          }
        }}
        onChange={(e) => doSetValue(e.target.value)}
        fullWidth
      />
      {show_message && <p>{value?.message}</p>}
    </>
  )
}

export default Main;
